import { Box, Link } from '@mui/material'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'

const ForgotPasswordConfirmation = () => {
  return (
    <>
      <Typography color={'secondary'} varianant={'p'}>
        {I18n.t('auth.forgotPasswordConfirmed')}
      </Typography>
      <Box display={'flex'} justifyContent={'flex-end'} mb={4} mt={4}>
        <Link to="/login" variation={'primary'} width={'small'}>
          {I18n.t('auth.backToLogin')}
        </Link>
      </Box>
    </>
  )
}

export default ForgotPasswordConfirmation
